module.exports = __webpack_public_path__ + "static/012_001-fe5b406223cf6c299bd5038563e00c1f.jpg";